import React from "react";
import { Dropbox } from "react-bootstrap-icons";
import { useDrop } from "react-dnd";

const DropArea = ({ addField }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "FORM_FIELD",
    drop: (item) => addField(item.fieldType),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div
      ref={drop}
      style={{
        border: "1px solid #f0f0f0",
        padding: "10px",
        backgroundColor: isOver ? "#fff" : "#f0f0f0",
        textAlign: 'center',
        padding: '20px 0px 20px 0px',
        marginTop: "30px"
      }}
    >
      <Dropbox
        style={{
          color: "#454444",
          width: "25px",
          height: "25px"
        }}
      />
    </div>
  );
};

export default DropArea;
